import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import { computed, defineComponent, ref, toRefs, watch } from "@vue/composition-api";
import { isEmpty } from "lodash";
import { useI18n } from "vue-i18n-composable";
export default defineComponent({
  name: "SelectApplicationStep",
  props: {
    files: {
      type: Array,
      required: true
    },
    selectedFiles: {
      type: Array,
      required: true
    }
  },
  setup(props, {
    emit
  }) {
    const {
      t
    } = useI18n();
    const {
      files,
      selectedFiles
    } = toRefs(props);
    const selectAll = ref();
    const allFilesSelected = computed(() => !isEmpty(selectedFiles.value) && files.value.length === selectedFiles.value.length);
    const table = computed(() => ({
      columns: ["selected", "fileName"],
      options: {
        filterable: false,
        sortable: [],
        headings: {
          selected: "",
          fileName: t("global.words.document")
        },
        perPage: 999999,
        tabbable: false,
        skin: "table mb-0",
        columnsClasses: {
          selected: "w-10 text-center",
          fileName: "w-30"
        },
        texts: {
          noResults: t("request-package.requestDocuments.emptyDocumentsClassification.full")
        }
      }
    }));
    watch(allFilesSelected, value => {
      if (selectAll.value) selectAll.value.checked = value;
    });
    const isFileSelected = fileId => {
      var _context;
      return !!_findInstanceProperty(_context = selectedFiles.value).call(_context, ({
        id
      }) => id === fileId);
    };
    const handleSelectFile = file => {
      emit("selectFile", {
        type: isFileSelected(file.id) ? "unselect" : "select",
        file
      });
    };
    const handleSelectAllFiles = () => {
      emit("selectAllFiles", {
        type: allFilesSelected.value ? "unselect" : "select"
      });
    };
    return {
      t,
      allFilesSelected,
      table,
      selectAll,
      isFileSelected,
      handleSelectFile,
      handleSelectAllFiles
    };
  }
});